import type { ObservationImagesProps } from "./observation-images.type";
import type { GalleryItem } from "@/ui/gallery";

import { useTranslation } from "react-i18next";

import EmptyData from "@/components/EmptyData";
import { DatasetImageNode } from "@/modules/dataset-image/dataset-image-node";
import { Gallery } from "@/ui/gallery";

import { getNumberOfMasonryColumns } from "./observation-images.helper";

export const ObservationImages = ({ observation }: ObservationImagesProps) => {
  const { images } = observation;
  const { t } = useTranslation();

  if (!images?.length)
    return <EmptyData description={t("observation:noImage")} />;

  const numberOfColumns = getNumberOfMasonryColumns(images);

  const items = images.map(
    ({ id, url, name, description, labeling_object }): GalleryItem => {
      const imageProps = {
        src: `${url}`,
        alt: name,
        labeling: labeling_object,
      };
      return {
        key: `${id}`,
        title: name,
        description: description ?? "",
        node: <DatasetImageNode {...imageProps} hideBoundingBoxLabels />,
        previewNode: <DatasetImageNode {...imageProps} />,
      };
    }
  );

  return <Gallery items={items} breakpointCols={numberOfColumns} />;
};
